// Document categories shared by web Documents and the native Documents screen,
// so both group the same records under the same labels.
export const DOCUMENT_CATEGORIES = [
  { key: "cruise", label: "Cruise", matches: ["cruise_booking_confirmation", "cruise_booking"] },
  { key: "flights", label: "Flights", matches: ["flight_booking", "boarding_pass", "flight"] },
  { key: "hotels", label: "Hotels", matches: ["hotel_booking", "hotel"] },
  { key: "insurance", label: "Insurance", matches: ["insurance_policy", "insurance"] },
  { key: "transportation", label: "Transportation", matches: ["transportation_booking", "rental_car_booking", "parking_booking", "transfer_booking", "transportation", "rental_car", "parking"] },
  { key: "other", label: "Other", matches: [] },
];

export function documentCategoryKey(doc) {
  const k = String(doc?.document_type || doc?.kind || doc?.canonical_object_type || "").toLowerCase();
  for (const c of DOCUMENT_CATEGORIES) {
    if (c.key !== "other" && c.matches.some((m) => k === m || k.includes(m))) return c.key;
  }
  return "other";
}

export function groupDocumentsByCategory(docs) {
  const buckets = Object.fromEntries(DOCUMENT_CATEGORIES.map((c) => [c.key, []]));
  for (const d of docs || []) buckets[documentCategoryKey(d)].push(d);
  return buckets;
}

export const UNLINKED_SECTION_TITLE = "Not linked to a cruise";
export const UNLINKED_SECTION_NOTE =
  "These aren't attached to a cruise you can open. Only you can see them.";

// Shown on a document whose cruise was deleted or is no longer shared with you.
export const CRUISE_UNAVAILABLE_HINT = "Its cruise is no longer available";

export function documentDisplayName(doc) {
  return doc?.original_filename || doc?.filename || "Document";
}
